/**
 * 首页api
 */
import CommonUtils from 'utils/CommonUtils';
import dayaoAxios from 'axios';
var config = {
  baseURL: 'https://www.dayaotex.com/',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'POST,GET',
    'Access-Control-Allow-Headers': 'Authorization,Origin, X-Requested-With, Content-Type, Accept'
  },
  timeout: 0,
  withCredentials: false,
  responseType: 'json'
};
var dayaoAjax = dayaoAxios.create(config);
export default {
  get: function get(url, param) {
    return new Promise(function (resolve, reject) {
      dayaoAjax.get(url, {
        params: param
      }).then(function (result) {
        if (typeof result.data === 'string') {
          result.data = CommonUtils.parse(result.data);
        }

        resolve(result.data);
      }, function (err) {
        reject(err);
      });
    });
  }
};